import { getTime } from './TimeUtils';

export const NEWEST_FIRST = 1;
export const OLDEST_FIRST = -1;
/**
 * Helper function for sorting objects with Array.prototype.sort():
 *
 * myArray.sort((a, b) => sortByTime(a, b, "birthday", "ASC");
 *
 * Sort given objects by time, where time is a property of object
 * (e.g. person.birthday).
 * In this case the propertyName param is "birthday".
 *
 * @param a            The first object to compare
 * @param b            The second object to compare
 * @param propertyName The name of the given object's property to compare
 * @param direction    Whether direction is ascending or descending ["ASC"|"DESC"] ("DESC" = newest first)
 * @returns {number}   Returns 1 if a is before b, -1 if b is before a or 0 if properties are equal.
 */
const sortByTime = (propertyName, direction) => (a, b) => {
  return dateComparator(a[propertyName], b[propertyName], direction);
};

export const sortByProperty = (propertyName) => (a, b) => {
  if (a[propertyName] > b[propertyName]) {
    return 1;
  } else if (a[propertyName] > b[propertyName]) {
    return -1;
  } else {
    return 0;
  }
};

export const sortByMultiple =
  (...sortFunctions) =>
  (a, b) => {
    for (let i = 0; i < sortFunctions.length; i++) {
      let result = sortFunctions[i](a, b);
      if (result !== 0) {
        return result;
      }
    }
    return 0;
  };

export const sortByTimeNewestFirst = (propertyName) => (a, b) => {
  return sortByTime(propertyName, NEWEST_FIRST)(a, b);
};

export const sortByTimeOldestFirst = (propertyName) => (a, b) => {
  return sortByTime(propertyName, OLDEST_FIRST)(a, b);
};
/**
 *
 * @param a
 * @param b
 * @param direction 1 if newest should be first
 * @returns {*} -1 if a should come before b, 1 if b should come before a, 0 if equal
 */
export const dateComparator = (a, b, direction) => {
  let timeA = getTime(a),
    timeB = getTime(b);

  if (timeA.isSame(timeB)) {
    return 0;
  }

  if (timeA.isBefore(timeB)) {
    return direction;
  } else {
    return direction * -1;
  }
};
